import { useRef, useState } from 'react'
import s from './ResetPasswordForm.scss'
import { Formik } from 'formik'
import * as Yup from 'yup'
import { Container, Col, Form, FormGroup, Label, Input, Button, Alert } from 'reactstrap'
import { Turnstile } from '@marsidev/react-turnstile'
import { Spinner } from 'components/ideal-core-ui'

const TURNSTILE_SITE_KEY =
  typeof window !== 'undefined' && window.Cypress ? '' : process.env.TURNSTILE_SITE_KEY

const ResetPasswordForm = props => {
  const { formSubmit, isSuccess, isError } = props
  const [turnstileToken, setTurnstileToken] = useState('')
  const turnstileRef = useRef(null)
  const turnstileRequired = Boolean(TURNSTILE_SITE_KEY)

  return (
    <Formik
      props={props}
      initialValues={{ email: '' }}
      onSubmit={async (values, { setSubmitting }) => {
        try {
          await formSubmit(
            { ...values, turnstileToken },
            {
              onError: () => {
                setTurnstileToken('')
                turnstileRef.current?.reset()
              }
            }
          )
        } finally {
          setTimeout(() => setSubmitting(false), 2000)
        }
      }}
      validationSchema={Yup.object().shape({
        email: Yup.string().email('Invalid email address').required('Email is required!')
      })}
    >
      {props => {
        const { values, touched, errors, isSubmitting, handleBlur, handleChange, handleSubmit } =
          props

        return (
          <Container className={s.container}>
            <div className={s.header} />
            <Form className={s.form} onSubmit={handleSubmit}>
              <p className={s.title}>
                Enter your email so we can send you <br /> a link to reset your password
              </p>
              <Col>
                <FormGroup className={s.group}>
                  <Label for="email">Your Email Address</Label>
                  <Input
                    type="text"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.email}
                    name="email"
                    placeholder="email@example.com"
                    disabled={isSubmitting}
                  />
                  {errors.email && touched.email && (
                    <div className={s.inputFeedback}>{errors.email}</div>
                  )}
                </FormGroup>
              </Col>
              {turnstileRequired && (
                <Col>
                  <FormGroup className={s.group} data-cy="turnstile_widget">
                    <Turnstile
                      ref={turnstileRef}
                      siteKey={TURNSTILE_SITE_KEY}
                      onSuccess={setTurnstileToken}
                      onExpire={() => setTurnstileToken('')}
                      onError={() => setTurnstileToken('')}
                    />
                  </FormGroup>
                </Col>
              )}
              <Button
                className={s.loginBtn}
                type="submit"
                disabled={isSubmitting || (turnstileRequired && !turnstileToken)}
              >
                {isSubmitting ? <Spinner /> : 'Submit'}
              </Button>
              <div className={s.clearfix} />
              {isSuccess && (
                <Alert className={s.marginTop} color="success">
                  A reset link was sent to your account. Please click on it in order to change your
                  password
                </Alert>
              )}
              {isError && (
                <Alert className={s.marginTop} color="danger">
                  An error has occured. Please contact support
                </Alert>
              )}
            </Form>
          </Container>
        )
      }}
    </Formik>
  )
}

export default ResetPasswordForm
